export default {
    it: {
        "pec_or_peo_email": "Selezionare la tipologia di casella email su cui si intende ricevere le comunicazioni di OAM",
        "alert_not_ok": "<strong>Attenzione!</strong> Devi selezionare la tipologia di casella email su cui si intende ricevere le comunicazioni di OAM per proseguire."
       
    },
    en: {
        "pec_or_peo_email": "Pec o peo",
        "alert_not_ok": "<strong>Attention!</strong> You must select the type of email address on which you wish to receive OAM communications to continue."
    }
}